import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ClaimsJsonValidatorComponent } from 'app/shared/components/debug-tools/claims-json-validator/claims-json-validator.component';

@Injectable()
export class ClaimsJsonValidatorService<TRequest = unknown, TResponse = unknown> {
    private dialogRef: MatDialogRef<ClaimsJsonValidatorComponent>;

    public constructor(private readonly dialog: MatDialog) {
    }

    public open(data?: TRequest): Observable<TResponse> {
        const config: MatDialogConfig<TRequest> = {
            data,
            disableClose: true,
            maxWidth: '100%',
            width: '75rem',
            panelClass: ['ppi-dialog', 'mobile-fullscreen-dialog'],
        };

        this.dialogRef = this.dialog.open(ClaimsJsonValidatorComponent, config);
        return this.dialogRef.afterClosed();
    }

    public close(result?: unknown): void {
        if (!this.dialogRef) {
            return;
        }

        this.dialogRef.close(result);
    }
}
